
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import UNData, { UNDataRequired } from "./UNData";
import { mapGetters } from "vuex";
import { Money } from "v-money";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { MONEY as settingMoney } from "@/modules/Application";
import { onboardStore } from "../../../onboardStore";

export default {
  name: "app-un-form",
  props: {
    url: {
      type: String,
    },
    un: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [validationMixin, SistemaMixin],
  data() {
    return {
      onboardStore,
      tabIndex: 0,
      form: {},
      configMoney: settingMoney,
      tiposConversor: [
        {
          id: 1,
          descricao: "Multiplição",
        },
        {
          id: 2,
          descricao: "Divisão",
        },
      ],
      unidadesMedidas: [],
    };
  },
  validations: {
    form: UNDataRequired,
  },
  components: {
    Money,
    VueSelect,
  },
  watch: {
    un(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
      }
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }

    this.getDataInit();
  },
  methods: {
    async getDataInit() {
      this.form = await new UNData({});
      this.unidadesMedidas = await this.getUnidadeMedidas();
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_nova_un"];

      try {
        this.$v.form.$touch();

        if (this.$v.form.$anyError) {
          this.$toast.error(
            "Verifique todos os campos obrigatórios do formulário!"
          );
          return;
        }

        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");

        await this.$http.post(this.url, this.form);
        if (this.onboardStore.currentStep > 0) {
          this.onboardStore.currentStep = 6;
        }
        this.$router.push({ name: "unidades" });
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
  },
};
